import {toLocalString} from 'shared/utils/dateTime';
import {Dependencies} from './types';

export function inspectablePrimitive<TPrimitive extends UnixTimeStamp>(
  entity: TPrimitive,
  di: Dependencies = {}
): LocalDateTimeString {
  const {converter = toLocalString} = di;
  return converter(entity);
}
